import React from 'react';
import {
  Select,
  MenuItem,
  InputBase,
  withStyles,
  FormControl,
  makeStyles,
  useTheme,
  Checkbox,
} from '@material-ui/core';
import KenTextLabel from '../KenTextLabel';

function getStyles(name, value, theme) {
  return {
    fontWeight:
      value.indexOf(name) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium,
  };
}

const useStyles = makeStyles((theme) => ({
  label: {
    marginBottom: 2,
  },
  selectMenuItem: {
    '&.Mui-selected': {
      backgroundColor: `1px solid ${theme.palette.KenColors.primary}`,
      fontWeight: 600,
    },
  },
}));

const BootstrapInput = withStyles((theme) => ({
  root: {
    'label + &': {
      marginTop: theme.spacing(3),
    },
  },
  input: {
    borderRadius: 4,
    position: 'relative',
    // backgroundColor: '#FAFBFC',
    border: '1px solid #ced4da',
    fontSize: 10,
    padding: '5px 10px 2px 5px',
    textAlign: 'left',
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    // Use the system font instead of the default Roboto font.
    '&:focus': {
      borderRadius: 4,
      borderColor: '#80bdff',
      boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
    },
    //   ...inputStyles,
  },
}))(InputBase);

const KenSelect = function (props) {
  const {
    id,
    options = [],
    value,
    onChange,
    label,
    name,
    placeholder,
    disabled,
    readonly,
    defaultValue,
    required,
    multiple,
    optionalLabel = true,
    dropdownColor,
    inputInputProps,
    menuItemProps,
  } = props;

  const useStyles = makeStyles((theme) => ({
    label: {
      marginBottom: 2,
    },
    selectMenuItem: {
      '&.Mui-selected': {
        // background: selectedMenuColor,
        color: '#DE350B',
        fontWeight: 600,
      },
    },
  }));

  const classes = useStyles();

  const handleCheck = (elem) => {
    if (value?.includes(elem.value)) {
      return true;
    }
    return false;
  };

  const handleRenderValue = (selected) => {
    if (!selected) return;
    if (multiple) {
      return selected.map((el) => {
        return options.find((item) => item.value === el)?.label;
      });
    } else {
      return options.find((item) => item.value === selected)?.label;
    }
  };

  const theme = useTheme();
  return (
    <FormControl
      fullWidth
      disabled={disabled || readonly}
      className={classes.formControl}
      //   variant="filled"
    >
      <KenTextLabel
        label={label}
        required={required}
        optionalLabel={optionalLabel}
      />
      <Select
        data-testid="kenSelect"
        id={id}
        name={name}
        label={label}
        value={value}
        onChange={onChange}
        disabled={disabled || readonly}
        fullWidth
        placeholder={placeholder}
        input={<BootstrapInput value={value} inputProps={inputInputProps} />}
        required={required}
        multiple={multiple}
        defaultValue={defaultValue}
        style={{ backgroundColor: dropdownColor }}
        renderValue={(selected) => {
          return multiple
            ? handleRenderValue(selected).join(',')
            : handleRenderValue(selected);
        }}
        {...props}
      >
        {options.map((el) => (
          <MenuItem
            key={el.label || el}
            value={el.value || el}
            style={
              multiple
                ? getStyles(name, value, theme)
                : { backgroundColor: el?.backgroundColor }
            }
            selected={value === el.value}
            classes={{ selected: classes.selectMenuItem }}
            disabled={
              menuItemProps?.condition
                ? el.value === menuItemProps?.condition
                : menuItemProps?.menuItemDisabled
            }
            {...menuItemProps}
          >
            {multiple && <Checkbox checked={handleCheck(el)} />}
            {el.label || el}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

const KenSelectWrap = (props = {}) => {
  const options = props?.options?.map((option) =>
    typeof option === 'string' || option instanceof String
      ? { label: option, value: option }
      : option
  );

  return <KenSelect {...props} options={options} />;
};
export default KenSelectWrap;
